if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"PrettyLoad","remotes":[]},
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}